/* @flow */

import React from "react";
import { connect } from "react-redux";
import Button from "../../Button";
import FilePicker from "../../FilePicker";
import Fieldset from "../../Fieldset";
import { DocumentCollectionStep } from "./DocumentCollectionStep";
import type { RootState } from "../../../types";
import countryConfig from "../../../countryConfig";

export class DocumentManager extends DocumentCollectionStep {
  render() {
    return (
      <React.Fragment>
        <Fieldset
          title={
            countryConfig[this.props.countryCode].contacts.documentManager.title
          }
          description={
            countryConfig[this.props.countryCode].contacts.documentManager
              .description
          }>
          <FilePicker
            description="Adding documentation is optional at this time; however, we will request them later during the application review process. Adding documentation now can help speed up the application review process."
            files={this.state.documents}
            onFileUpload={this.handleFileCollectionAdd}
            onFileRemove={this.handleFileCollectionRemove}
            onFileUploadStatus={this.handleFileUploadStatusChange}
          />
        </Fieldset>

        <Button
          intent="primary"
          fullWidth={true}
          onClick={this.commitDocuments}
          disabled={this.props.ui.asyncActionInFlight}>
          Done
        </Button>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ ui, countryCode }: RootState) => ({
  ui,
  countryCode
});

// $FlowFixMe
export default connect(mapStateToProps)(DocumentManager);
